import { message as antdMessage } from 'antd';

/**
 * Centralized message utility wrapper for antd message component
 * Use this instead of importing message directly from antd
 */

const message = {
    success: (content, duration = 3, onClose) => {
        return antdMessage.success({
            content,
            duration,
            onClose
        });
    },

    error: (content, duration = 3, onClose) => {
        return antdMessage.error({
            content,
            duration,
            onClose
        });
    },

    warning: (content, duration = 3, onClose) => {
        return antdMessage.warning({
            content,
            duration,
            onClose
        });
    },

    info: (content, duration = 3, onClose) => {
        return antdMessage.info({
            content,
            duration,
            onClose
        });
    },

    loading: (content, duration = 0, onClose) => {
        return antdMessage.loading({
            content,
            duration,
            onClose
        });
    },

    destroy: () => {
        antdMessage.destroy();
    }
};

export default message;
